import React from 'react';
import { contactInfo } from '../data/mock';
import { Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="heading-2 footer-brand">Wellness Impress</h3>
            <p className="body-regular footer-tagline">
              Rééquilibrez votre corps, apaisez votre esprit.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 footer-title">Navigation</h4>
            <nav className="footer-nav">
              <a href="#services" className="footer-link">Nos Soins</a>
              <a href="#about" className="footer-link">À Propos</a>
              <a href="#testimonials" className="footer-link">Avis Clients</a>
              <a href="#contact" className="footer-link">Contact</a>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 footer-title">Contact</h4>
            <div className="footer-contact">
              <a href={`tel:${contactInfo.phone}`} className="footer-contact-item">
                <Phone size={16} />
                <span className="body-small">{contactInfo.phone}</span>
              </a>
              <a href={`mailto:${contactInfo.email}`} className="footer-contact-item">
                <Mail size={16} />
                <span className="body-small">{contactInfo.email}</span>
              </a>
              <a href={contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="footer-contact-item">
                <Instagram size={16} />
                <span className="body-small">{contactInfo.instagram}</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 footer-title">Horaires</h4>
            <div className="footer-hours">
              <p className="body-small">Sur rendez-vous uniquement</p>
              <p className="body-small">{contactInfo.location}</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small footer-copyright">
            © {currentYear} Wellness Impress. Tous droits réservés.
          </p>
          <div className="footer-legal">
            <a href="#" className="body-small footer-legal-link">Mentions Légales</a>
            <a href="#" className="body-small footer-legal-link">Politique de Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;